import { FunctionComponent } from 'react';
import Image from "next/legacy/image";

interface CircleIconProps {
  icon: string;
  className: string;
}

const Circle: FunctionComponent<CircleIconProps> = ({ icon, className }) => {
  return (
    <figure
      className={`rounded-full flex justify-center items-center h-8 w-8 ${className}`}
    >
      <div className="w-full">
        <Image
          src={icon}
          blurDataURL={icon}
          placeholder="blur"
          loading="eager"
          layout="responsive"
          width={2500}
          height={2000}
          alt=""
        />
      </div>
    </figure>
  );
};

export default Circle;
